import { gql } from '@apollo/client';

export const GET_PROFILE = gql`
  query GetProfile {
    getUser {
      id
      name
      email
      phone
    }
  }
`;

export const LIST_MY_BOOKS = gql`
  query ListMyBooks(
    $sorting: Sorting
    $pagination: Pagination
    $myAds: Boolean
  ) {
    listBooks(sorting: $sorting, pagination: $pagination, myAds: $myAds) {
      id
      title
      subtitle
      author
      comment
      price
      isbn
      updatedAt
      createdAt
      product {
        id
        title
        subtitle
        thumbnail
        author
      }
    }
  }
`;
